const OfflineModeAlertBox = ({ localisedValues }) => {
    return (
        <div className='offline-mode-alert'>
            <div className='offline-mode-alert-in'>
                <div className='offline-mode-alert-box'>
                    <div className='alert-icon'>
                        <span className='for-icon icon-offline-mode'></span>
                    </div>
                    <div className='alert-text'>
                        <span className='alert-text-highlight'>{localisedValues?.offline_mode_enabled}</span>
                        {localisedValues?.your_images_will_upload_when_you_reconnect} {localisedValues?.please_keep_this_screen_open}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OfflineModeAlertBox;
